export default function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fns/esm/_lib/toInteger/index.js
// module id = ./node_modules/date-fns/esm/_lib/toInteger/index.js
// module chunks = 1 2 3